<template>
  <div>
    <b-container class="p-0 a-menu" fluid="md">
      <b-row no-gutters>
        <b-container>
          <b-navbar class="box-rounded-top" toggleable="sm" type="dark" variant="dark" >
            <b-navbar-toggle target="website-menu">
              <font-awesome-icon class="m-1" icon="bars"/>
              <div class="menu-text">MENÚ</div>
            </b-navbar-toggle>
            <b-navbar-nav class="w-100" justified>
              <b-nav-item
                  class="d-none d-sm-block"
                  v-for="option in menuOptions"
                  :key="option.id"
                  :to="option.url"
                  :disabled="option.id === page"
              >{{ option.title }}
              </b-nav-item>
            </b-navbar-nav>
          </b-navbar>
        </b-container>
      </b-row>
    </b-container>

    <b-sidebar
      id="website-menu"
      title="Menú"
      bg-variant="dark"
      text-variant="light"
      backdrop
      shadow
      @shown="backdropToggle(true)"
      @hidden="backdropToggle(false)"
    >
      <div class="px-3 py-2">
        <b-nav vertical class="w-10">
          <b-nav-item
              v-for="option in menuOptions"
              :key="option.id"
              :to="option.url"
              :active="option.id === page"
          >
            <b-icon
              v-if = "option.icon"
              :icon="option.icon"
              font-scale=".95"
              class="rounded-circle mx-2 mb-1"/>
            {{ option.title }}
          </b-nav-item>
        </b-nav>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { contentComputed } from '@state/helpers'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars } from '@fortawesome/free-solid-svg-icons'

library.add(faBars)

export default {
  name: "Menu",

  props: {
    page: {
      type: String,
      default: null
    }
  },

  computed: {
    ...contentComputed
  },

  methods: {
    backdropToggle(shown) {
      shown
        ? document.body.classList.add('sidebar-shown')
        : document.body.classList.remove('sidebar-shown');
    }
  }
}
</script>

<style lang="scss">
  @import '@design';

  .a-menu nav{
    background-color: $color-menu-bg !important;
  }

  .navbar-dark .navbar-toggler,
  .a-menu .navbar-dark .navbar-nav .nav-link{
    font-weight: bold;
    text-transform: uppercase;
    color: $color-container-text !important;
    background-color: $color-menu-bg !important;
  }

  .navbar-dark .navbar-toggler{
    margin: 5px;
  }

  .navbar {
    padding: 0;
  }

  .navbar-dark .navbar-nav .nav-link.disabled {
    color: $color-menu-bg !important;
    background-color: $color-container-text !important;
  }

  @media only screen and (min-width: 768px) {
    .navbar {
      max-height: 36px;
    }

    .box-rounded-top {
      overflow-x: hidden;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
    }
  }

  @media only screen and (max-width: 767px) {
    .a-menu .navbar-dark .navbar-nav .nav-link{
      font-size: medium;
      letter-spacing: 2px;
    }
  }

  .menu-text {
    float: right;
    margin-top: 4px;
    margin-left: 10px;
  }

  .navbar-dark .navbar-toggler {
    border-color: silver;
  }

  .b-sidebar-backdrop {
    left: 10px !important;
    height: 100%;
  }

  .bg-dark {
    background-color: $color-menu-bg !important;
  }

  .b-sidebar {
    width: 250px !important;
  }

  .b-sidebar-body a.nav-link {
    display: inline-block;
    width: 100%;
    margin-top: 5px;
    font-size: large;
    color: white;
    text-transform: uppercase;
  }

  .b-sidebar-body a.nav-link.active {
    font-weight: bold;
    color: $color-menu-bg !important;
    background-color: white !important;
  }

  #website-menu {
    height: 100%;
  }

  .b-sidebar-header strong {
    text-transform: uppercase;
  }

  .b-sidebar-header button {
    background-color: $color-menu-bg;
    border-width: 0;
  }

  .navbar-toggler:focus,
  .navbar-toggler:active,
  .navbar-toggler-icon:focus {
    outline: none;
    box-shadow: none;
  }

  body.sidebar-shown {
    overflow-y: hidden;
  }
</style>
